import React from "react";
import { Box, IconButton } from "@mui/material";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import { useMap } from "react-leaflet";

/** Zoom column for CareMap “stacked” layout (carousel docks on map bottom; zoom stays top-right). */
const MapStackedZoomControls = () => {
  const map = useMap();

  return (
    <Box
      sx={{
        position: "absolute",
        top: 8,
        right: 5,
        zIndex: 10002,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <IconButton
        onClick={() => map.zoomIn()}
        size="small"
        sx={{
          backgroundColor: "background.paper",
          boxShadow: 2,
          width: 32,
          height: 32,
          borderRadius: "4px 4px 0 0",
          "&:hover": {
            backgroundColor: "background.paper",
            boxShadow: 4,
          },
        }}
        aria-label="Zoom in"
      >
        <AddIcon color="primary" fontSize="small" />
      </IconButton>
      <IconButton
        onClick={() => map.zoomOut()}
        size="small"
        sx={{
          backgroundColor: "background.paper",
          boxShadow: 2,
          width: 32,
          height: 32,
          borderRadius: "0 0 4px 4px",
          marginTop: "1px",
          "&:hover": {
            backgroundColor: "background.paper",
            boxShadow: 4,
          },
        }}
        aria-label="Zoom out"
      >
        <RemoveIcon color="primary" fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default MapStackedZoomControls;
